import styled from 'styled-components';

interface EyebrowProps {
  $variant?: 'default' | 'amber';
}

export const Eyebrow = styled.p<EyebrowProps>`
  margin: 0;
  font-size: ${(p) => p.theme.step[0]}px;
  font-weight: 500;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: ${(p) =>
    p.$variant === 'amber' ? p.theme.color.accent.amber : p.theme.color.text[2]};
`;
